<template>
  <div class="container">
    <scroller :on-refresh="refresh">
      <div class="container">
        <div class="row">
          <div class="col-md-8" style="margin: 0 auto">
            <div class="header" @click="getIntroduce">
              <div class="profile-box">
                <img :src="user.avatar" alt />
              </div>
              <div class="nickFile">
                <p class="text1">Hi,{{ user.nickName }}</p>
                <p class="text2">欢迎来到个人中心</p>
              </div>
              <div class="right-box">
                <!-- <span>个人信息 ></span> -->
                <img src="../../assets/img/smallBell.png" alt />
              </div>
            </div>
            <div class="center-box">
              <div class="ranking-box">
                <div class="rankitem" @click="getTimeCount">
                  <img src="../../assets/img/ranking.png" alt />
                  <span>本周排名</span>
                </div>
                <div class="rankitem" @click="certification">
                  <img src="../../assets/img/papers.png" alt />
                  <span>完善资料</span>
                </div>
                <div
                  class="rankitem"
                  @click="qualification"
                  v-show="user.userType == 2"
                >
                  <img src="../../assets/img/IMMP.png" alt />
                  <span>资质认证</span>
                </div>
              </div>
              <div class="count-box">
                <div class="countitem">
                  <p>
                    <span>{{ sumTime }}</span
                    >分钟
                  </p>
                  <p>总学习时长</p>
                </div>
                <div class="countitem">
                  <p>
                    <span>{{ CollectTotalCount || 0 }}</span
                    >个
                  </p>
                  <p>收藏直播</p>
                </div>
                <div class="countitem">
                  <p>
                    <span>{{ AttentionTotalCount || 0 }}</span
                    >个
                  </p>
                  <p>关注主题</p>
                </div>
              </div>
            </div>
            <div class="content">
              <div class="column-box">
                <p class="title">我的学习</p>
                <ul>
                  <li @click="getOrder">
                    <img src="../../assets/img/icon_calendar.png" alt />
                    <span>已购直播</span>
                  </li>
                  <!--<li>
                  <img src="../../assets/img/icon_live.png" alt />
                  <span>观看历史</span>
                  </li>-->
                  <li @click="getCollect">
                    <img src="../../assets/img/upstarSet.png" alt />
                    <span>我的收藏</span>
                  </li>
                  <li @click="getAttention">
                    <img src="../../assets/img/attention.png" alt />
                    <span>我的关注</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </scroller>
    <!-- 底部选项卡 -->
    <div class="container">
      <div class="row">
        <mt-tabbar
          :selected="selected"
          class="col-md-8"
          style="margin: 0 auto; max-width: 760px"
        ></mt-tabbar>
      </div>
    </div>
  </div>
</template>

<script>
import MtTabbar from '../../components/Tabbar'
export default {
  // name: 'personal',
  data() {
    return {
      allLoaded: false,
      clientHeight: 0,
      userType: 1,
      mobile: '',
      selected: 'user',
      user: {},
      userId: '',
      openId: '',
      CollectTotalCount: '',
      AttentionTotalCount: '',
      sumTime: '',
      pageIndex: 1
    }
  },
  components: { MtTabbar },

  mounted() {
    this.user = JSON.parse(sessionStorage.getItem('userInfo'))
    this.userId = sessionStorage.getItem('userId')
    this.getSumTime()
    this.getAttentionList()
    this.getCollectList()
    this.noShare()
  },

  methods: {
    refresh() {
      location.reload()
    },
    // 跳转我的收藏
    getCollect() {
      // this.$router.push('/collect')
      const routeData = this.$router.resolve({
        path: '/collect'
        // query: { liveId: liveId }
      })
      window.open(routeData.href, '_blank')
    },
    // 跳转我的关注
    getAttention() {
      this.$router.push('/attention')
      const routeData = this.$router.resolve({
        path: '/attention'
        // query: { liveId: liveId }
      })
      window.open(routeData.href, '_blank')
    },
    // 获取用户总时长
    getSumTime() {
      this.$http({
        url: `/live/liveUserTime/getSumTime/${this.userId}`,
        method: 'get'
      }).then(({ data }) => {
        if (data && data.code === 0) {
          this.sumTime = data.sumTime
        } else {
          this.sumTime = 0
        }
      })
    },
    // 获取关注视频数量
    getAttentionList() {
      this.$http({
        url: `/live/userInterest/queryOKLives`,
        method: 'get',
        params: {
          pageNo: this.pageIndex,
          userId: this.userId,
          status: 1,
          pageSize: 100
        }
      }).then(({ data }) => {
        if (data && data.code === 0) {
          if (data.data) {
            this.AttentionTotalCount = data.data.records.length
          }
        } else {
          this.AttentionTotalCount = 0
        }
      })
    },
    // 获取当前用户的收藏数量
    getCollectList() {
      this.$http({
        url: `/live/userInterest/queryOKLives`,
        method: 'get',
        params: {
          pageNo: this.pageIndex,
          userId: this.userId,
          status: 2,
          pageSize: 100
        }
      }).then(({ data }) => {
        if (data && data.code === 0) {
          if (data.data) {
            this.CollectTotalCount = data.data.records.length
          }
        } else {
          this.CollectTotalCount = 0
        }
      })
    },
    // 资质认证
    qualification() {
      // this.$router.push('/qualification')
      const routeData = this.$router.resolve({
        path: '/qualification'
        // query: { liveId: liveId }
      })
      window.open(routeData.href, '_blank')
    },
    // 观看时长周排名
    getTimeCount() {
      // this.$router.push('/weektime')
      const routeData = this.$router.resolve({
        path: '/weektime'
        // query: { liveId: liveId }
      })
      window.open(routeData.href, '_blank')
    },
    // 实名认证
    certification() {
      // this.$router.push('/certification')
      const routeData = this.$router.resolve({
        path: '/certification'
        // query: { liveId: liveId }
      })
      window.open(routeData.href, '_blank')
    },
    // 修改资料
    getIntroduce() {
      // this.$router.push('/introduce')
      const routeData = this.$router.resolve({
        path: '/introduce'
        // query: { liveId: liveId }
      })
      window.open(routeData.href, '_blank')
    },
    // 跳转到我的直播
    getOrder() {
      // this.$router.push('/order')
      const routeData = this.$router.resolve({
        path: '/order'
        // query: { liveId: liveId }
      })
      window.open(routeData.href, '_blank')
    }
  }
}
</script>
<style lang="scss" scoped>
.count-box {
  padding-top: 8rem;
  text-align: center;
  display: flex;
  justify-content: space-around;
  .countitem {
    color: #666;
    text-align: left;
    font-size: 14px;
    line-height: 25px;
    p:nth-child(1) {
      color: #999;
      span {
        color: #333;
        font-size: 18px;
        padding-right: 5px;
      }
    }
  }
}
.container {
  width: 100%;
  height: 100%;
  .header {
    height: 18rem;
    // background: #737373;
    background: url(../../assets/img/timg.jpg) no-repeat;
    position: relative;
    box-sizing: border-box;
    padding: 10px;
    // color: #ffffff;
    color: #566079;
    .profile-box {
      width: 6rem;
      height: 6rem;
      border: 2px solid #ffffff;
      border-radius: 50%;
      float: left;
      margin: 2rem 0.4rem 0 1rem;
      img {
        width: 100%;
        height: 100%;
        overflow: hidden;
        border-radius: 50%;
      }
    }
    .nickFile {
      position: absolute;
      left: 85px;
      margin: 2rem 0.4rem 0 1rem;
      .text1 {
        font-size: 22px;
      }
      .text2 {
        margin-top: 5px;
        font-size: 14px;
      }
    }
    .right-box {
      float: right;
      margin: 4.8rem 1rem 0 0;
      img {
        width: 2.2rem;
      }
    }
  }
  .center-box {
    width: 100%;
    height: 14rem;
    background: #e8e8e8;
    position: relative;
    .ranking-box {
      position: absolute;
      width: 88%;
      height: 9rem;
      background: #fff;
      left: 6%;
      top: -4rem;
      border-radius: 4px;
      display: flex;
      justify-content: space-around;
      box-shadow: 0 2px 8px rgba(255, 255, 255, 0.7);
      .rankitem {
        display: flex;
        font-size: 14px;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        color: #666;
        img {
          width: 5rem;
          height: 5rem;
        }
      }
    }
  }
  .content {
    width: 100%;
    .column-box {
      margin: 1rem;
      .title {
        font-size: 18px;
        margin: 1rem;
      }
      ul {
        display: flex;
        flex-wrap: wrap;
        margin: 2rem 0;
        width: 100%;
        color: #666;
        font-size: 14px;
        li {
          width: 33.3%;
          display: flex;
          margin-bottom: 2rem;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          img {
            width: 2rem;
            margin-bottom: 10px;
          }
        }
      }
    }
  }
}
</style>
